import React from 'react';
import { bonuses } from '../data/modules';
export function BonusSection() {
  return <section className="bg-brand-carbon px-4 py-4 text-white" data-id="element-18" data-mp="1og41f5rb6r7r">
      <div className="mx-auto max-w-3xl" data-id="element-19" data-mp="1oflyxre1zgre">
        <h2 className="mb-2.5 text-center font-display text-[20px] leading-tight text-white sm:text-3xl" data-id="element-20" data-mp="22g52al7kpyn8">
          🎁 5 Professional Bonuses Included
        </h2>
        <ul className="space-y-2" data-id="element-21" data-mp="1ybx8waq67uio">
          {bonuses.map(bonus => <li key={bonus.number} data-id="element-22" data-mp="1apif172nbz54">
              <article className="rounded-lg border border-brand-yellow/50 bg-brand-steel p-3" data-id="element-23" data-mp="1amcrhw9o15bi">
                <h3 className="font-cond text-[14px] font-bold leading-snug text-brand-yellow sm:text-lg" data-id="element-24" data-mp="15n9kw7e1er1f">
                  🎁 Bonus {bonus.number} — {bonus.title}
                </h3>
                <p className="mb-1 font-cond text-[12px] font-semibold uppercase tracking-wide text-white sm:text-sm" data-id="element-25" data-mp="1eohfaedfn7q8">
                  {bonus.subtitle}
                </p>
                <p className="text-[13px] font-medium leading-snug text-brand-line sm:text-[15px]" data-id="element-26" data-mp="mxtjziyfwwkh">
                  {bonus.body}
                </p>
                <p className="mt-1 font-cond text-[12px] font-bold uppercase tracking-wide text-brand-yellow sm:text-sm" data-id="element-27" data-mp="29q8pqnjcl3i6">
                  {bonus.tagline}
                </p>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}